<script setup>
	import { ref, computed } from 'vue'
   import config from '@/config'

   const localMedia = config.localMedia

	const props = defineProps({
		src: String,
		alt: String,
		class: String,
		smallSpinner: Boolean,
		tinySpinner: Boolean,
	})

	const isLoaded = ref(false)
	const isBroken = ref(false)
	const imageLoaded = () => isLoaded.value = true
	const imageFailed = () => isBroken.value = true

	const imageClass = computed(() => {
		return props.class ?? false
	})
</script>

<template>
	<!-- Loading Image -->
	<div v-if="! isLoaded && ! isBroken" class="image-loader">
		<img :src="`${localMedia}/default-blank.svg`" :alt="alt">
		<div class="spinner-wrapper">
			<div class="spinner-border spinner text-primary" :class="{'spinner-small': smallSpinner, 'spinner-tiny': tinySpinner}">
				<span class="visually-hidden">Loading...</span>
			</div>
		</div>
	</div>

	<!-- Broken Image -->
	<div v-if="isBroken" class="image-loader">
		<img :src="`${localMedia}/default-featured-blank.svg`" :alt="alt" :class="imageClass">
		<div class="broken-wrapper">
			<FontAwesomeIcon icon="fa-regular fa-image-slash" />
		</div>
	</div>

	<!-- Loaded Image -->
	<img v-show="isLoaded" @load="imageLoaded()" @error="imageFailed()" :class="imageClass" :src="src" :alt="alt">
</template>